// Filename: public/BIEventsFunctions.js 
import { biLoggerFactory } from 'wix-private';

const msid = "69de3d7b-0af8-482c-b2fe-3415a53bf46d"; //replace the value between quotes with your site msid value

const biGroupsLoggers = {
    19: biLoggerFactory('get-started', 19, { msid }),
}

export async function fireBIEvent(src, evid, fields) {

    const biLogger = biGroupsLoggers[src];
    try {
        const biEventObject = {
            evid,
            ...fields
        };
        await biLogger.log(biEventObject);
        console.log('BI Event Fired Successfully with ', biEventObject);

    } catch (err) {
        console.error(`Failed to fireBIEvent -err- ${err}`);
    }
}